import {makeStyles} from "@material-ui/core";

export default function CardFileCss() {
    return makeStyles((theme)=>({
        card: {
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        cardFileText: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 2,
        },
        input: {
            display: 'none',
        },
        buttonFile: {
            marginTop: 2,
            marginBottom: 2
        },
        button: {
            margin: 2,
            marginTop: 12,
        },
        textField: {
            width: '100%',
        },
        multilineColor: {
            color: 'rgb(118, 118, 118) !important',
            borderBottomColor: '#159B78 !important',
            "&::after": {
                borderBottomColor: '#159B78 !important',
            }
        },
        textFieldLabel: {
            color: 'rgb(118, 118, 118)'
        },
        acoes: {
            marginLeft: '5px',
            position: 'inherit',
            float: 'right'
        }
    }));
}